import { apiRequest, USE_MOCKS } from './client'
import type { JobListResponse, JobDetail } from '@/types'
import { mockJobs, mockJobDetail } from '@/mocks/jobs'

export async function listJobs(params?: {
  node_id?: string
  status?: string
  type?: string
  started_from?: string
  started_to?: string
  limit?: number
  offset?: number
}): Promise<JobListResponse> {
  if (USE_MOCKS) return mockJobs(params)
  const qs = new URLSearchParams()
  if (params?.node_id) qs.set('node_id', params.node_id)
  if (params?.status) qs.set('status', params.status)
  if (params?.type) qs.set('type', params.type)
  if (params?.started_from) qs.set('started_from', params.started_from)
  if (params?.started_to) qs.set('started_to', params.started_to)
  if (params?.limit != null) qs.set('limit', String(params.limit))
  if (params?.offset != null) qs.set('offset', String(params.offset))
  const query = qs.toString() ? `?${qs}` : ''
  return apiRequest<JobListResponse>(`/api/jobs${query}`)
}

export async function getJob(jobId: string): Promise<JobDetail> {
  if (USE_MOCKS) return mockJobDetail(jobId)
  return apiRequest<JobDetail>(`/api/jobs/${jobId}`)
}

export async function cancelJob(jobId: string): Promise<void> {
  return apiRequest<void>(`/api/jobs/${jobId}/cancel`, { method: 'POST' })
}
